import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { ChangeCalendarView } from './Calendar';
import CoreComponent from 'utilities/component-utilities/CoreComponent';

// #region model definition
interface CalendarYearProps {
    name: string
    value: number,
    onChange: (view: ChangeCalendarView, e: React.MouseEvent) => void
    minDate?: Date
    maxDate?: Date,
    isDisabled: (year: number) => boolean,
    highlightDates?: Array<Date> | null,
}
interface CalendarYearState {
    yearCalculate: number
}

const yearsToShow = 12;
// #endregion model definition
class CalendarYear extends CoreComponent<CalendarYearProps, CalendarYearState> {
    readonly today: Date;
    constructor(props: CalendarYearProps) {
        super(props);

        this.today = new Date();
        this.state = {
            yearCalculate: this.calculateViewYear(this.props.value)
        };
    }

    // #region logic
    private calculateViewYear = (year?: number) => {
        year = year || this.props.value;
        return Math.floor((year - 1970) / yearsToShow) * yearsToShow;
    }

    private goToToday = (e: React.MouseEvent) => {
        this.props.onChange({
            month: this.today.getMonth(),
            year: this.today.getFullYear(),
            view: 'date'
        }, e);
    }

    private changeYearCalculator = (calc: number) => {
        const val = this.state.yearCalculate + (calc * yearsToShow);
        const year = 1970 + val;
        if (this.props.minDate && (year + yearsToShow) < this.props.minDate.getFullYear()) return;
        if (this.props.maxDate && year > this.props.maxDate.getFullYear()) return;
        if (val < 0) return;
        this.setState({
            yearCalculate: val
        });
    }

    private onChange = (year: number, disabled: boolean, e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled) return;
        this.props.onChange({ year, view: 'month' }, e);
    }
    // #endregion logic

    // #region render

    private renderYear = () => {
        const yearsView: React.ReactNode[] = [];
        let rowView: React.ReactNode[] = [];

        let start = 1970 + this.state.yearCalculate;

        for (let year = start, row = 0; year < (start + yearsToShow); year++, row++) {
            const disabled = this.props.isDisabled(year);
            rowView.push(
                <td key={`year-${year}`}>
                    <button
                        type="button"
                        name={`${this.props.name}-calendar-year-${year}`}
                        className={`month-cell 
                            ${this.props.value === year ? 'selected' : ''}
                            ${disabled ? 'disabled' : ''}
                            ${this.props.highlightDates?.some(d => d.getFullYear() === year) ? 'highlight' : ''}
                        `}
                        onClick={e => this.onChange(year, disabled, e)}
                    >
                            <span>{year}</span>
                    </button>
                </td >
            );

            if (row === 2) {
                row = -1;
                yearsView.push(<tr key={`year-row-${yearsView.length}`}>{[...rowView]}</tr>);
                rowView = [];
            }
        }

        return yearsView;
    }

    render() {
        return (
            <>
                <header className="calendar-header">
                    <div className='flex gap-4 text-4xl float-right'>
                        <button aria-label='up' type='button' onClick={e => this.changeYearCalculator(1)} ><FontAwesomeIcon icon={faCaretUp} /></button>
                        <button aria-label='down' type='button' onClick={e => this.changeYearCalculator(-1)} ><FontAwesomeIcon icon={faCaretDown} /></button>
                    </div>
                    <div className='pt-2 pb-2'>
                        <button type='button' onClick={e => this.props.onChange('month', e)} >
                            {this.t('button.back')}
                        </button>
                        <button type='button' className='ml-6' onClick={e => this.goToToday(e)} >
                            {this.t('calendar.today')}
                        </button>
                    </div>
                </header>
                <div className="calendar-content">
                    <table className="month-view">
                        <tbody>
                            {this.renderYear()}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
    // #endregion render
}
export default CalendarYear;
